/* import __COLOCATED_TEMPLATE__ from './entries-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import ENV from 'bullitttime-event/config/environment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class EntriesTableComponent extends Component
{
	@service store;

	@tracked isAddingNew = false;
	@tracked hasLoadedEntries = false;

	// Only show loading state on initial load, not during saves
	get showLoadingState()
	{
		return !this.hasLoadedEntries && this.args.entries?.isPending;
	}

	constructor()
	{
		super(...arguments);
		// Track when entries first load
		if (this.args.entries?.then) {
			this.args.entries.then(() => {
				this.hasLoadedEntries = true;
			});
		} else if (this.args.entries) {
			this.hasLoadedEntries = true;
		}
	}
	
	@tracked newLastName = "";
	@tracked newFirstName = "";
	@tracked newBib = 0;
	@tracked newGender = "M";
	@tracked newDOB = "";
	@tracked newClub = "";
	@tracked newTown = "";
	@tracked newState = "";
	@tracked newCountry = "";
	@tracked newStartTime = "";
	@tracked newID1 = "";
	@tracked newID2 = "";
	@tracked newID3 = "";
	@tracked newPts1 = "";
	@tracked newPts2 = "";
	@tracked newPts3 = "";
	@tracked newPts4 = "";
	@tracked newPts5 = "";
	@tracked newClass = null;
	
	get entriesCSVLink()
	{
		var event = this.args.event;
		return ENV.resultsBackendProtocol+"://"+ENV.resultsBackendHost+":"+ENV.resultsBackendPort+(ENV.resultsBackendNamespace ? "/"+ENV.resultsBackendNamespace : "")+"/events/"+event.id+"/startlist/individuals?format=csv";
	}
	
	@action
	toggleIsAddingNew()
	{
		this.isAddingNew = !this.isAddingNew;
		// Wrap scrollIntoView in try-catch to prevent test failures
		try {
			const footer = document.getElementById("entriesTableCardFooter");
			if (footer && footer.scrollIntoView) {
				footer.scrollIntoView();
			}
		} catch (e) {
			// Ignore scroll errors in test environment
		}
	}
	
	@action
	async classSelectionChanged(browserEvent)
	{
		const eventClass = browserEvent.target.value;
		
		if(eventClass == '-')
		{
			this.newClass = null;
		}
		else
		{
			const foundClass = await this.store.findRecord('class', eventClass);
			this.newClass = foundClass;
		}	
	}
	
	@action
	async saveNew(browserEvent)
	{	
		browserEvent.preventDefault();
		
		var event = this.args.event;
		var store = this.store;
		
		var startTimeEntered = this.newStartTime;
		var parsedStartTime = dayjs(startTimeEntered, "HH:mm:ss");

		var eventDate = dayjs(event.date);
		parsedStartTime = parsedStartTime
			.year(eventDate.year())
			.month(eventDate.month())
			.date(eventDate.date());
		
		const newEntry = store.createRecord('Entry',
		{
			firstName: this.newFirstName,
			lastName: this.newLastName,
			bib: this.newBib,
			gender: this.newGender,
			DOB: this.newDOB,
			club: this.newClub,
			town: this.newTown,
			state: this.newState,
			country: this.newCountry,
			status: "OK",
			EventId: event,
			id1: this.newID1,
			id2: this.newID2,
			id3: this.newID3,
			pts1: this.newPts1,
			pts2: this.newPts2,
			pts3: this.newPts3,
			pts4: this.newPts4,
			pts5: this.newPts5,
			ClassId: this.newClass
		});

		try
		{
			await newEntry.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newEntry.rollbackAttributes();
			return;
		}

		const newSTR = store.createRecord('StartTimingRecord',
		{
			EntryId: newEntry,
			participatesInAutoAssociation: true,
			assignedStartTime: new Date(parsedStartTime.toISOString()),
			EventId: event,
		});

		try
		{
			await newSTR.save();
			newEntry.StartTimingRecordId = newSTR;
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newSTR.rollbackAttributes();
			return;
		}

		this.newFirstName = "";
		this.newLastName = "";
		this.newBib = 0;
		this.newGender = "M";
		this.newDOB = "";
		this.newClub = "";
		this.newTown = "";
		this.newState = "";
		this.newCountry = "";
		this.newStartTime = "";
		this.newID1 = "";
		this.newID2 = "";
		this.newID3 = "";
		this.newPts1 = "";
		this.newPts2 = "";
		this.newPts3 = "";
		this.newPts4 = "";
		this.newPts5 = "";
		this.newClass = null;
		
		this.isAddingNew = false;
	}
	
	@action
	cancelNew()
	{
		this.newFirstName = "";
		this.newLastName = "";
		this.newBib = 0;
		this.newGender = "M";
		this.newDOB = "";
		this.newClub = "";
		this.newTown = "";
		this.newState = "";
		this.newCountry = "";
		this.newStartTime = "";
		this.newID1 = "";
		this.newID2 = "";
		this.newID3 = "";
		this.newPts1 = "";
		this.newPts2 = "";
		this.newPts3 = "";
		this.newPts4 = "";
		this.newPts5 = "";
		this.newClass = null;
		
		this.isAddingNew = false;
	}
}